import * as React from "react";

import { Autocomplete, Chip, TextField } from "@mui/material";

const MultipleSelect = ({
  options,
  selectedValues,
  setSelectedValues,
  placeholder,
  transparent
}) => {
  return (
    <div style={{ width: "100%" }}>
      <Autocomplete

        style={{ backgroundColor: transparent ? 'transparent' : "#fff" }}
        value={selectedValues}
        onChange={(event, newValue) => {
          setSelectedValues(newValue);
        }}
        multiple
        autoComplete='off'

        freeSolo
        id="tags-filled"
        options={options}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              style={{ marginTop: 6 }}
              variant="secondary"
              label={option.label}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={placeholder}
            placeholder=""
          />
        )}
      />
    </div>
  );
};

export default MultipleSelect;
